import moment from 'moment';
//过滤对象空字段
export function filterEmptyFields(obj) {
  return Object.keys(obj)
    .filter(key => obj[key] !== null && obj[key] !== undefined && obj[key] !== '')
    .reduce((acc, key) => {
      acc[key] = obj[key];
      return acc;
    }, {});
}
export function S4() {
    // 0x   表示16进制数据的开头
    //可以直接return (((1+Math.random())*0x10000)|0).toString(16)；    
    
    //也可用如下，随机数*时间戳，再转化为16进制
    //Number.toString(16)    表示将其转换为16进制
    // Number | 0 表示取整数部分
  
   let stamp = new Date().getTime();
   return (((1+Math.random())*stamp)|0).toString(16)    
  }
// 防抖函数
export function debounce(fn, arg) {
  // delay = delay || 1000;
  let delay = 2000;
  let timeout;
  return function() {
    let context = this;
    if (timeout) clearTimeout(timeout);

    let callNow = !timeout;
    timeout = setTimeout(() => {
      timeout = null;
    }, delay);
    if (callNow) fn.apply(context, arg);
  };
}

export function downloadFileUrl(url, fileName) {
	const a = document.createElement("a");
	a.style.display = "none";
	a.setAttribute("target", "_blank");
	/*
	 * download的属性是HTML5新增的属性
	 * href属性的地址必须是非跨域的地址，如果引用的是第三方的网站或者说是前后端分离的项目(调用后台的接口)，这时download就会不起作用。
	 * 此时，如果是下载浏览器无法解析的文件，例如.exe,.xlsx..那么浏览器会自动下载，但是如果使用浏览器可以解析的文件，比如.txt,.png,.pdf....浏览器就会采取预览模式
	 * 所以，对于.txt,.png,.pdf等的预览功能我们就可以直接不设置download属性(前提是后端响应头的Content-Type: application/octet-stream，如果为application/pdf浏览器则会判断文件为 pdf ，自动执行预览的策略)
	 */
	fileName && a.setAttribute("download", fileName);
	a.href = url;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
}
export function fixedZero(val) {
    return val * 1 < 10 ? `0${val}` : val;
}

export function getTimeDistance(type) {
    const now = new Date();
    const oneDay = 1000 * 60 * 60 * 24;

    if (type === 'today') {
        now.setHours(0);
        now.setMinutes(0);
        now.setSeconds(0);
        return [moment(now), moment(now.getTime() + (oneDay - 1000))];
    }

    if (type === 'week') {
        let day = now.getDay();
        now.setHours(0);
        now.setMinutes(0);
        now.setSeconds(0);

        if (day === 0) {
            day = 6;
        } else {
            day -= 1;
        }

        const beginTime = now.getTime() - day * oneDay;

        return [moment(beginTime), moment(beginTime + (7 * oneDay - 1000))];
    }

    if (type === 'month') {
        const year = now.getFullYear();
        const month = now.getMonth();
        const nextDate = moment(now).add(1, 'months');
        const nextYear = nextDate.year();
        const nextMonth = nextDate.month();

        return [
            moment(`${year}-${fixedZero(month + 1)}-01 00:00:00`),
            moment(moment(`${nextYear}-${fixedZero(nextMonth + 1)}-01 00:00:00`).valueOf() - 1000),
        ];
    }

    if (type === 'year') {
        const year = now.getFullYear();

        return [moment(`${year}-01-01 00:00:00`), moment(`${year}-12-31 23:59:59`)];
    }
}

export function getPlainNode(nodeList, parentPath = '') {
    const arr = [];
    nodeList.forEach(node => {
        const item = node;
        item.path = `${parentPath}/${item.path || ''}`.replace(/\/+/g, '/');
        item.exact = true;
        if (item.children && !item.component) {
            arr.push(...getPlainNode(item.children, item.path));
        } else {
            if (item.children && item.component) {
                item.exact = false;
            }
            arr.push(item);
        }
    });
    return arr;
}
/**
 * @description 将数值金额转换成大写金额
 * @date 2019-01-29
 * @export
 * @param {*} n 数值金额
 * @returns string
 */
export function digitUppercase(n) {
    const fraction = ['角', '分'];
    const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
    const unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']];
    let num = Math.abs(n);
    let s = '';
    fraction.forEach((item, index) => {
        s += (digit[Math.floor(num * 10 * 10 ** index) % 10] + item).replace(/零./, '');
    });
    s = s || '整';
    num = Math.floor(num);
    for (let i = 0; i < unit[0].length && num > 0; i += 1) {
        let p = '';
        for (let j = 0; j < unit[1].length && num > 0; j += 1) {
            p = digit[num % 10] + unit[1][j] + p;
            num = Math.floor(num / 10);
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }

    return s
        .replace(/(零.)*零元/, '元')
        .replace(/(零.)+/g, '零')
        .replace(/^整$/, '零元整');
}

/**
 * @description 判断两个字符串关系
 * @date 2019-01-29
 * @param {*} str1
 * @param {*} str2
 * @returns number
 */
function getRelation(str1, str2) {
    if (str1 === str2) {
        console.warn('Two path are equal!'); // eslint-disable-line
    }
    const arr1 = str1.split('/');
    const arr2 = str2.split('/');
    if (arr2.every((item, index) => item === arr1[index])) {
        return 1;
    } else if (arr1.every((item, index) => item === arr2[index])) {
        return 2;
    }
    return 3;
}

function getRenderArr(routes) {
    let renderArr = [];
    renderArr.push(routes[0]);
    for (let i = 1; i < routes.length; i += 1) {
        let isAdd = false;
        // 是否包含
        isAdd = renderArr.every(item => getRelation(item, routes[i]) === 3);
        // 去重
        renderArr = renderArr.filter(item => getRelation(item, routes[i]) !== 1);
        if (isAdd) {
            renderArr.push(routes[i]);
        }
    }
    return renderArr;
}

/**
 * 随机生成字符串
 * @param {*} len
 */
export function randomString(len, simple=0) {
    len = len || 32;
    let $chars = simple ? 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678' : '123456789';
    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    let maxPos = $chars.length;
    let pwd = '';
    for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}

/**
 * Get router routing configuration
 * { path:{name,...param}}=>Array<{name,path ...param}>
 * @param {string} path
 * @param {routerData} routerData
 */
export function getRoutes(path, routerData) {
    let routes = Object.keys(routerData).filter(
        routePath => routePath.indexOf(path) === 0 && routePath !== path
    );
    // Replace path to '' eg. path='user' /user/name => name
    routes = routes.map(item => item.replace(path, ''));
    // Get the route to be rendered to remove the deep rendering
    const renderArr = getRenderArr(routes);
    // Conversion and stitching parameters
    const renderRoutes = renderArr.map(item => {
        const exact = !routes.some(route => route !== item && getRelation(route, item) === 1);
        return {
            exact,
            ...routerData[`${path}${item}`],
            key: `${path}${item}`,
            path: `${path}${item}`,
        };
    });
    return renderRoutes;
}

/* eslint no-useless-escape:0 */
const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/g;
// 验证url是否正确
export function isUrl(path) {
    return reg.test(path);
}

// 验证url是否正确
export function sumTotal(num1, num2) {
    num1 = Number(num1)//string类型转换为number类型
    num2 = Number(num2)//string类型转换为number类型
    let sumtotal = parseFloat(num1)+parseFloat(num2)//浮点类型转换相加求和
    sumtotal = sumtotal.toFixed(2)//保留两位小数
  return sumtotal;
}

// 正则规则整理
export const regular = {
// 验证自然数
naturalNumber: /^(([0-9]*[1-9][0-9]*)|(0+))$/,
// 英文
english: /^.[A-Za-z]+$/,
// 验证是否是座机号
telephone: /^\d{3}-\d{7,8}|\d{4}-\d{7,8}$/,
// 手机号
mobile: /^1[345789]\d{9}$/,
// 银行卡号码
bankCard: /^[1-9]\d{9,19}$/,
// 证件号码
IDNumber: /^[a-z0-9A-Z]{0,50}$/,
// 身份证号码,包括15位和18位的
IDCard: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{7}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/,
// QQ号码
qq: /^[1-9]\d{4,11}$/,
// 网址, 仅支持http和https开头的
url: /^(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?$/,
// 0到20位的英文字符和数字
enNum0to20: /^[a-z0-9A-Z]{0,20}$/,
// 2到100位的中英文字符和空格，可以是中文、英文、空格
cnEnSpace2to100: /^[a-zA-Z\u4E00-\u9FA5\s*]{2,100}$/,
// 数字和换行符
numLinefeed: /^[0-9\n*]+$/,
// 255位以内的字符
char0to255: /^.{0,255}$/,
}
export default {
    /**
     * 时间日期格式化
     * @param format
     * @returns {*}
     */
    dateFormat (dateObj, format) {
        let date = {
        'M+': dateObj.getMonth() + 1,
        'd+': dateObj.getDate(),
        'h+': dateObj.getHours(),
        'm+': dateObj.getMinutes(),
        's+': dateObj.getSeconds(),
        'q+': Math.floor((dateObj.getMonth() + 3) / 3),
        'S+': dateObj.getMilliseconds()
        }
        if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (dateObj.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (let k in date) {
        if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length === 1
            ? date[k] : ('00' + date[k]).substr(('' + date[k]).length))
        }
        }
        return format
    }
}


/**
 *把数组对象 转成特定的数组对象
 [{a:'部门1'，b:12,son：[{a:'部门2'，b:18}]}] 
[{label:'部门1'，value:12,children：[{label:'部门2'，value:18}]}] 
 * @param arr
 * @param label
 * @param value
 * @param childrenKey
 * @returns
 */
export const gettreeList = (
    arr,
    label,
    value,
    childrenKey='children'
  ) => {
    let res = []
    const get_children_list = (
      arr=[],
      label,
      value,
      childrenKey
    ) => {
      const tempArr = []
  
      for (let index = 0; index < arr.length; index++) {
        const item = arr[index]
  
        const tempObj = {
          label: item[label],
          value: item[value],
          children: []
        }
  
        if (item[childrenKey]) {
          tempObj.children = get_children_list(
            item[childrenKey],
            label,
            value,
            childrenKey
          )
          if(!tempObj.children.length){
            delete tempObj.children
          }
        }
  
        tempArr.push(tempObj)
      }
  
      res = tempArr
      return tempArr
    }
    get_children_list(arr, label, value, childrenKey)
    return res
  }

export const SALARY_TYPE_LIST = [
	{ label: "日结", value: 1 },
	{ label: "周结", value: 2 },
	{ label: "月结", value: 3 },
	{ label: "次结", value: 4 },
	{ label: "完工结", value: 5 },
    { label: "小时结", value: 6 },
];
export const SALARY_TYPE_TEXT = ["", "日结", "周结", "月结", "次结", "完工结","小时结"];
  /**
 * 获取薪酬单位文本
 * @param {Object} data 薪酬单位数据
 * @returns {String} 薪酬单位文本
 */
export const getSalaryTypeText = (
	data,
	min_key = "min_salary",
	max_key = "max_salary",
	salary_type_key = "salary_type"
) => {
	let min_salary = parseInt(data[min_key] || 0);
	let max_salary = parseInt(data[max_key] || 0);
	if (min_salary > 0 && max_salary > 0) {
		if (min_salary == max_salary) {
			return `${max_salary}/${SALARY_TYPE_TEXT[data[salary_type_key]]}`;
		} else {
			return `${min_salary}-${max_salary}元/${
				SALARY_TYPE_TEXT[data[salary_type_key]]
			}`;
		}
	} else {
		return "面议";
	}
};


  export const tog_SALARY_TYPE_LIST = [
	{ label: "次结", value: 1 },
	{ label: "小时结", value: 2 },
	{ label: "日结", value: 3 },
	{ label: "周结", value: 4 },
	{ label: "月结", value: 5 },
    { label: "完工结", value: 6 },
];
export const tog_SALARY_TYPE_TEXT = ["", "次结","小时结", "日结", "周结", "月结", "完工结"];
  /**
 * 获取薪酬单位文本
 * @param {Object} data 薪酬单位数据
 * @returns {String} 薪酬单位文本
 */
export const tog_getSalaryTypeText = (
	data,
	min_key = "min_salary",
	max_key = "max_salary",
	salary_type_key = "salary_type"
) => {
	let min_salary = parseInt(data[min_key] || 0);
	let max_salary = parseInt(data[max_key] || 0);
	if (min_salary > 0 && max_salary > 0) {
		if (min_salary == max_salary) {
			return `${max_salary}/${tog_SALARY_TYPE_TEXT[data[salary_type_key]]}`;
		} else {
			return `${min_salary}-${max_salary}元/${
				tog_SALARY_TYPE_TEXT[data[salary_type_key]]
			}`;
		}
	} else {
		return "面议";
	}
};



